import { useState, Fragment } from 'react';
import { css } from 'twin.macro';
import { BsFillPlusSquareFill } from 'react-icons/bs';
import { CreateEventStyle } from '@/components/Admin/Tasks/Styles/EventModalStyles';
import { EventModalForm } from '@/components/Admin/Tasks/EventModalForm';
import styled from '@emotion/styled';
import { BootstrapToolTip } from '@/_elements/ToolTip';

export const StyledCreateChannelToggle = styled.div`
    width: 100%;
    height: 60px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #50aeb0;
    opacity: 0.8;
    :hover {
        opacity: 1;
    }
`;
function EventModal({ handleSubmitTask, customTeams, teamIds }) {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        setShow(true);
    };
    return (
        <Fragment>
            <BootstrapToolTip text="Create New Event">
                <div
                    css={css`
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 10px;
                    `}
                >
                    <StyledCreateChannelToggle onClick={handleShow}>
                        <span>
                            <BsFillPlusSquareFill color="white" fontSize={30} />
                        </span>
                    </StyledCreateChannelToggle>
                </div>
            </BootstrapToolTip>

            <CreateEventStyle size="lg" centered show={show} onHide={handleClose}>
                <EventModalForm
                    handleSubmitTask={handleSubmitTask}
                    handleClose={handleClose}
                    mode={'create'}
                    showTeamFilter={true}
                    customTeams={customTeams}
                    teamIds={teamIds}
                />
            </CreateEventStyle>
        </Fragment>
    );
}
export default EventModal;
